
import { Container, Row, Col } from "react-bootstrap"

export const DetailsQuotationSkeletonLoader = () => {
  return (
    <>
      <div
        style={{
          borderRadius: 7,
          background: "#fff",
          height: "calc(100vh - 12vh)",
          border: "1px solid lightblue",
          overflow: "clip",
        }}
      >
        {/* Header Skeleton */}
        <div
          className="header mb-0 position-sticky top-0 p-3"
          style={{
            borderBottom: "1px solid lightblue",
            zIndex: 11,
            background: "#fff",
          }}
        >
          <div className="d-flex align-center justify-content-between">
            <div className="skeleton-text" style={{ width: "250px", height: "28px" }}></div>
            <div className="d-flex align-items-center">
              <div className="skeleton-element me-2" style={{ width: "80px", height: "39px" }}></div>
              <div className="skeleton-element me-2" style={{ width: "100px", height: "39px" }}></div>
              <div className="skeleton-element me-2" style={{ width: "80px", height: "39px" }}></div>
              <div className="skeleton-element" style={{ width: "40px", height: "39px" }}></div>
              <div className="skeleton-element ms-3" style={{ width: "40px", height: "39px" }}></div>
            </div>
          </div>
        </div>

        <div
          className="form-container"
          style={{
            margin: 0,
            overflowY: "auto",
            height: "100%",
            paddingLeft: "0px",
            paddingTop: "12px",
            position: "relative",
          }}
        >
          <Row className="ms-0 w-100 mb-0">
            <Col md={2} style={{ borderRight: "1px solid #d4e7ed" }}>
              <div style={{ position: "sticky", top: "1rem" }} className=" mt-3">
                <ul className=" ps-3" style={{ listStyle: "none" }}>
                  {[1, 2, 3].map((item) => (
                    <li key={item} className="position-relative border-start ps-3 py-2 ps-4">
                      <div className="skeleton-circle" style={{ width: "10px", height: "10px" }}></div>
                      <div className="skeleton-text" style={{ width: "130px", height: "16px", marginLeft: "15px" }}></div>
                    </li>
                  ))}
                </ul>
                <hr />
              </div>
            </Col>

            <Col md={10} className="ps-3">
              {/* Company Details Section Skeleton */}
              <Row className="ms-0 w-100" style={{ paddingRight: 4 }}>
                <Col md={6} className="ps-0 mb-4">
                  <div className="skeleton-card ps-2" style={{ height: "500px" }}>
                    <div className="skeleton-text mb-4" style={{ width: "180px", height: "24px" }}></div>
                    
                    {[1, 2, 3, 4, 5, 6].map((item) => (
                      <div key={item} className="mb-3">
                        <div className="skeleton-text" style={{ width: "100px", height: "16px", marginBottom: "5px" }}></div>
                        <div className="skeleton-text" style={{ width: "80%", height: "20px" }}></div>
                      </div>
                    ))}
                  </div>
                </Col>
                
                <Col md={6} className="mb-4 ms-0 ps-0 pe-0">
                  <div className="skeleton-card ps-3" style={{ height: "500px" }}>
                    <div className="skeleton-text" style={{ width: "150px", height: "24px", marginBottom: "20px" }}></div>
                    
                    <div className="mb-4">
                      <div className="skeleton-text" style={{ width: "90%", height: "16px", marginBottom: "5px" }}></div>
                      <div className="skeleton-text" style={{ width: "80%", height: "16px" }}></div>
                    </div>
                    
                    <div>
                      <div className="skeleton-text" style={{ width: "150px", height: "24px", marginBottom: "20px" }}></div>
                      <div className="skeleton-text" style={{ width: "90%", height: "16px", marginBottom: "5px" }}></div>
                      <div className="skeleton-text" style={{ width: "80%", height: "16px" }}></div>
                    </div>
                  </div>
                </Col>
              </Row>

              {/* Items Details Section Skeleton */}
              <Row style={{ width: "100%", marginLeft: 0, paddingRight: 4 }}>
                <div className="skeleton-text mb-3" style={{ width: "150px", height: "24px" }}></div>
                
                <Col md={12} className="pe-0 ps-0">
                  <div className="skeleton-card mb-3" style={{ height: "400px" }}>
                    <table className="table mb-0">
                      <thead>
                        <tr>
                          {["Items Name", "Quantity", "Rate", "GST(%)", "Discount", "Amount"].map((header, idx) => (
                            <th key={idx}>
                              <div className="skeleton-text" style={{ width: "70px", height: "16px", margin: "0 auto" }}></div>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {[1, 2, 3].map((row) => (
                          <tr key={row}>
                            {Array(6).fill(0).map((_, cellIdx) => (
                              <td key={cellIdx}>
                                <div className="skeleton-text" style={{ width: "80%", height: "16px", margin: "8px auto" }}></div>
                              </td>
                            ))}
                          </tr>
                        ))}
                        
                        <tr>
                          <td colSpan={6}>
                            <div className="skeleton-element" style={{ height: "200px", borderRadius: "5px" }}></div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Col>
              </Row>

              {/* Terms & Conditions Section Skeleton */}
              <Row>
                <Col md={8}>
                  <div className="skeleton-text mb-3" style={{ width: "200px", height: "24px" }}></div>
                  <div className="skeleton-text" style={{ width: "100%", height: "100px" }}></div>
                </Col>
                
                <Col md={4} className="mb-3">
                  <div className="skeleton-text mb-3" style={{ width: "120px", height: "24px" }}></div>
                  <div className="skeleton-element" style={{ width: "100%", height: "50px", borderRadius: "10px" }}></div>
                </Col>
              </Row>

              <div style={{ height: "10rem" }}></div>
            </Col>
          </Row>
        </div>
      </div>

      <style jsx>{`
        .skeleton-element {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 4px;
        }
        
        .skeleton-text {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 4px;
        }
        
        .skeleton-circle {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 50%;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
        
        .skeleton-card {
          border: 1px solid #e0e0e0;
          border-radius: 4px;
          padding: 15px;
        }
        
        @keyframes loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }
      `}</style>
    </>
  )
}